import {
    CropMapLocationCityResponse,
    CropMapLocationDistrictResponse,
    CropMapLocationRegionResponse,
    CropMapLocationStateResponse,
} from '../../proxy/proxies';

export class RegionModel extends CropMapLocationRegionResponse {
    countryId: number;

    constructor() {
        super();
    }
}

export class StateModel extends CropMapLocationStateResponse {
    countryId: number;

    constructor() {
        super();
    }
}

export class CityModel extends CropMapLocationCityResponse {
    countryId: number;
    regionId?: number;
    stateId?: number;

    constructor() {
        super();
    }
}

export class DistrictModel extends CropMapLocationDistrictResponse {
    countryId: number;
    regionId?: number;
    stateId?: number;
    cityId: number;

    constructor() {
        super();
    }
}
